import { loadSwiper } from '../../shared/js/modules/swiperLoader';
import { setSameHeight } from '../../shared/js/modules/utils';

//-----------------------------------
// ### Sliders ###
//------------------------------------

// Global Sliders Array
const sliders = [];

// Initiate Sliders if present on page
export function initiateSliders() {
  if ($('.swiper-container').length === 0) {
    return;
  }

  loadSwiper().done(() => {
    // Big slider on e.g. start page
    if ($('.teaser-hero-slider').length) {
      $('.teaser-hero-slider .swiper-container').each((index, element) => {
        let compagnion_slider = null;
        if ($(element).parents('.with-compagnion').length) {
          const $sharedParent = $(element).closest('.row');
          const $compagnionSlider = $('.compagnion-wrapper .swiper-container', $sharedParent);
          if ($compagnionSlider.length) {
            compagnion_slider = new Swiper($compagnionSlider, {
              loop: true,
              allowTouchMove: false,
              preventClicks: false,
            });
          }
        }

        let initialized = false;
        const teaser_hero_slider = new Swiper(element, {
          pagination: {
            el: $('.swiper-pagination', element),
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: $('.swiper-button-next', element),
            prevEl: $('.swiper-button-prev', element),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
          on: {
            init: function () {
              initialized = true;
            },
            slideNextTransitionStart: function () {
              if (compagnion_slider && initialized) {
                compagnion_slider.slideNext();
              }
            },
            slidePrevTransitionStart: function () {
              if (compagnion_slider && initialized) {
                compagnion_slider.slidePrev();
              }
            },
          },
        });
      });
    }

    // Banner slider on e.g. start page
    if ($('.teaser-banner-slider').length) {
      $('.teaser-banner-slider .swiper-container').each((index, element) => {
        const teaser_banner_slider = new Swiper(element, {
          pagination: {
            el: $('.swiper-pagination', element),
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: $('.swiper-button-next', element),
            prevEl: $('.swiper-button-prev', element),
          },
          loop: true,
          autoplay: {
            delay: 8000,
          },
        });
      });
    }

    // Slider on Product Detail Page
    let productDetailSliders = [];
    if ($('.product-detail-slider').length) {
      $('.product-detail-slider .swiper-container').each(function (index, element) {
        const product_detail_slider = new Swiper($('.product-detail-slider .swiper-container')[index], {
          pagination: {
            el: $('.product-detail-slider .swiper-pagination')[index],
            type: 'bullets',
            clickable: true,
          },
          on: {
            slideChange: () => {
              if (productDetailThumbnailSliders[index]) {
                // slide the thumbnail slider
                productDetailThumbnailSliders[index].slideTo(element.realIndex);
                // set active class for active preview
                productDetailThumbnailSliders[index].slides.removeClass('swiper-slide-fake-active');
                $(productDetailThumbnailSliders[index].slides[productDetailSliders[index].activeIndex]).addClass(
                  'swiper-slide-fake-active',
                );
              }
            },
          },
        });
        productDetailSliders[index] = product_detail_slider;
      });
    }

    // Thumbnail slider on Product Detail Page
    let productDetailThumbnailSliders = [];
    if ($('.product-detail-thumbnail-slider').length) {
      $('.product-detail-thumbnail-slider .swiper-container').each((i, e) => {
        const product_detail_thumbnail_slider = new Swiper($('.product-detail-thumbnail-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          navigation: {
            nextEl: $('.product-detail-thumbnail-slider .swiper-button-next')[i],
            prevEl: $('.product-detail-thumbnail-slider .swiper-button-prev')[i],
          },
          on: {
            tap: (event) => {
              const slide = $(event.target).closest('.swiper-slide');
              if (slide && typeof slide.data('index') !== 'undefined') {
                productDetailSliders[i].slideTo(slide.data('index'));
              }
            },
          },
        });
        productDetailThumbnailSliders[i] = product_detail_thumbnail_slider;
      });
    }

    // Category Slider
    if ($('.teaser-category-slider').length && $(window).width() < 992) {
      $('.teaser-category-slider .swiper-container').each((i) => {
        const teaser_category_slider = new Swiper($('.teaser-category-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: 15,
        });
      });
    }

    // Product Slider -- only initialise non empty ones:
    if ($('.teaser-product-slider:has(.swiper-wrapper > *)').length) {
      $('.teaser-product-slider .swiper-container').each((i, element) => {
        const hasSideNav = $('.side-nav').length ? 4 : 5; // if slider is on page that has a side nav only show 4 items per view and group
        const teaser_product_slider = new Swiper($(element), {
          slidesPerView: hasSideNav,
          slidesPerGroup: hasSideNav,
          breakpoints: {
            767: {
              slidesPerView: 1.75,
              slidesPerGroup: 1,
            },
            991: {
              slidesPerView: 3.6,
              slidesPerGroup: 1,
            },
            1200: {
              slidesPerView: 3.75,
              slidesPerGroup: 3.75,
            },
          },
          navigation: {
            nextEl: $(element).siblings('.swiper-button-next'),
            prevEl: $(element).siblings('.swiper-button-prev'),
          },
        });
        setSameHeight(element, '.product-list-item-header');
      });
    }

    // Auto Slider
    if ($('.teaser-auto-slider').length) {
      $('.teaser-auto-slider .swiper-container').each((i) => {
        const teaser_auto_slider = new Swiper($('.teaser-auto-slider .swiper-container')[i], {
          autoplay: {
            delay: 2500,
          },
        });
      });
    }

    // Benefits Slider
    if ($('.teaser-benefits-slider').length) {
      let _slidesPerView = $(window).width() > 767 ? 3 : 2;
      $('.teaser-benefits-slider .swiper-container').each((i) => {
        const teaser_benefits_slider = new Swiper($('.teaser-benefits-slider .swiper-container')[i], {
          slidesPerView: _slidesPerView,
          autoplay: {
            delay: 4000,
          },
        });
      });
    }

    // Customer Slider
    if ($('.teaser-customer-slider').length) {
      let _slidesPerView = $(window).width() > 991 ? 2 : 1;
      $('.teaser-customer-slider .swiper-container').each((i) => {
        const teaser_benefits_slider = new Swiper($('.teaser-customer-slider .swiper-container')[i], {
          slidesPerView: _slidesPerView,
          spaceBetween: 30,
          autoplay: {
            delay: 4000,
          },
        });
      });
    }

    // Brand Slider
    if ($('.teaser-brand-slider').length) {
      $('.teaser-brand-slider .swiper-container').each((i) => {
        const teaser_brand_slider = new Swiper($('.teaser-brand-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: 15,
        });
      });
    }

    // Advisor Slider
    if ($('.teaser-advisor-slider').length && $(window).width() < 992) {
      $('.teaser-advisor-slider .swiper-container').each((i) => {
        const teaser_advisor_slider = new Swiper($('.teaser-advisor-slider .swiper-container')[i], {
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: {
            nextEl: $('.teaser-advisor-slider .swiper-button-next')[i],
            prevEl: $('.teaser-advisor-slider .swiper-button-prev')[i],
          },
        });
      });
    }

    // Product List Combi Slider
    let productCombiSlider = {};

    if ($('.product-combi__slider .swiper-container').length) {
      $('.product-combi__slider .swiper-container').each((index, element) => {
        const activeIndex = $(element).find('.swiper-slide:has(.active)').index();
        productCombiSlider = new Swiper(element, {
          initialSlide: activeIndex ?? 0,
          slidesPerView: 'auto',
          spaceBetween: 15,
          freeMode: true,
        });

        if (window.matchMedia('screen and (min-width: 768px)').matches) {
          if (productCombiSlider !== undefined) {
            productCombiSlider.destroy(false, true);
          }
        }
      });
    }

    // Coupon Slider
    if ($('.coupon-slider').length) {
      $('.coupon-slider .swiper-container').each((i, element) => {
        const couponSlider = new Swiper(element, {
          slidesPerView: 3,
          spaceBetween: 15,
          breakpoints: {
            992: {
              slidesPerView: 2.25,
              spaceBetween: 15,
            },
            576: {
              slidesPerView: 1.25,
              spaceBetween: 10,
            },
          },
          navigation: {
            nextEl: $(element).siblings('.swiper-button-next'),
            prevEl: $(element).siblings('.swiper-button-prev'),
          },
          watchOverflow: true,
        });
      });
    }

    // Add Sliders to global Array sliders
    $('.swiper-container').each(function (index, element) {
      const swiper = this.swiper;
      if (swiper) {
        sliders.push(swiper);
      }
    });
  });
}

// Destroy Sliders
export function destroySliders() {
  $(sliders).each((index, element) => {
    element.destroy(false, true);
  });
}

// Toggle re-initialization and destruction of sliders if user switchs between
// tablet and desktop view
let windowWidth = $(window).width();
$(window).resize(() => {
  if ($(window).width() !== windowWidth) {
    destroySliders();
    initiateSliders();
    windowWidth = $(window).width();
  }
});
